import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "81",
  height: "87",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M28.591 64.154c2.161-3.622.901-8.522-3.06-10.885l2.05-3.436c5.719 3.413 7.82 10.715 4.445 16.37S21.228 73.48 15.51 70.068l2.05-3.435c3.96 2.363 8.871 1.144 11.032-2.478m-13.083 5.911c-3.417-2.039-8.058-.85-10.303 2.913-2.244 3.763-1.087 8.412 2.33 10.45l-2.049 3.435C.03 83.608-1.52 76.443 1.77 70.93s10.33-7.555 15.787-4.299zm56.961-34.182c3.962 2.364 5.222 7.264 3.06 10.886-2.16 3.622-7.07 4.84-11.032 2.477l-2.05 3.436c5.72 3.412 13.144 1.792 16.518-3.864s1.273-12.958-4.446-16.37zm-20.325 19.71c2.245-3.763 6.885-4.952 10.303-2.913l2.049-3.435c-5.457-3.256-12.497-1.216-15.787 4.299-3.29 5.514-1.74 12.679 3.716 15.934l2.05-3.435c-3.418-2.039-4.576-6.687-2.331-10.45M35.845 3.923c3.962 2.364 5.222 7.264 3.06 10.886-2.16 3.622-7.07 4.841-11.032 2.478l-2.05 3.435c5.72 3.412 13.144 1.792 16.518-3.863S43.614 3.9 37.895.489zM15.52 23.634c2.245-3.762 6.885-4.951 10.303-2.913l2.049-3.435c-5.457-3.255-12.497-1.215-15.787 4.3s-1.74 12.678 3.716 15.934l2.05-3.435c-3.418-2.04-4.576-6.688-2.331-10.45",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }